import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FolderOpen } from "lucide-react";
import { AppLayout } from "@/components/AppLayout";
import { StatusPill } from "@/components/StatusPill";
import api from "@/lib/api";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");
const fmtAmount = (a) => {
  if (a == null) return "—";
  const hasCents = Math.round(a * 100) % 100 !== 0;
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", minimumFractionDigits: hasCents ? 2 : 0, maximumFractionDigits: 2, useGrouping: "always" }).format(a);
};
const FILTERS = [{ v: "", t: "Todos" }, { v: "recibido", t: "Recibido" }, { v: "en_analisis", t: "En análisis" }, { v: "terminado", t: "Terminado" }];

export default function AdminAsuntos() {
  const [filter, setFilter] = useState("");
  const [rows, setRows] = useState(null);
  const navigate = useNavigate();

  const load = useCallback(() => {
    setRows(null);
    api.get("/admin/cases", { params: filter ? { status: filter } : {} })
      .then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, [filter]);

  useEffect(() => { load(); }, [load]);

  return (
    <AppLayout variant="admin">
      <div className="ddp-fade">
        <h1 className="ddp-serif" style={{ fontSize: "clamp(28px,4vw,40px)", color: "var(--burgundy-dark)", margin: 0, letterSpacing: "-.02em" }}>Asuntos</h1>
        <p style={{ color: "var(--muted)", fontSize: 15, marginTop: 8 }}>Todos los expedientes del piloto.</p>
      </div>

      <div style={{ display: "flex", gap: 8, marginTop: 22, flexWrap: "wrap" }}>
        {FILTERS.map((f) => (
          <button key={f.v} onClick={() => setFilter(f.v)} data-testid={`case-filter-${f.v || "all"}`}
            className={`ddp-btn ddp-btn-sm ${filter === f.v ? "ddp-btn-primary" : "ddp-btn-ghost"}`}>{f.t}</button>
        ))}
      </div>

      <div className="ddp-card" style={{ marginTop: 18, overflow: "hidden" }}>
        {rows === null ? <div style={{ padding: 40, color: "var(--muted)" }}>Cargando…</div>
          : rows.length === 0 ? (
            <div style={{ padding: "56px 24px", textAlign: "center" }}>
              <FolderOpen size={38} style={{ color: "var(--line)", margin: "0 auto 14px" }} />
              <div style={{ color: "var(--muted)" }}>No hay asuntos en este estado.</div>
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="ddp-table" data-testid="admin-cases-table">
                <thead><tr><th>Referencia</th><th>Despacho</th><th>Fecha</th><th>Cuantía</th><th>Tipo</th><th>Estado</th></tr></thead>
                <tbody>
                  {rows.map((c) => (
                    <tr key={c.id} data-testid={`admin-case-row-${c.reference}`} onClick={() => navigate(`/admin/asuntos/${c.id}`)}>
                      <td><span className="ddp-ref">{c.reference}</span></td>
                      <td style={{ fontWeight: 600 }}>{c.firm_name}</td>
                      <td style={{ color: "var(--muted)" }}>{fmtDate(c.created_at)}</td>
                      <td>{fmtAmount(c.amount)}</td>
                      <td><span style={{ fontSize: 12, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", letterSpacing: ".06em" }}>{c.type === "demo" ? "Caso cerrado" : "Asunto en curso"}</span></td>
                      <td><StatusPill status={c.status_display} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      </div>
    </AppLayout>
  );
}
